import { createFileRoute } from '@tanstack/react-router';
import { PersonalSecurityNewRoute } from './-route-wrappers';

export const Route = createFileRoute('/_authenticated/settings/personal/security/new')({
  component: PersonalSecurityNewRoute,
});
